module.exports = __webpack_public_path__ + "static/img/frontpage3.931935c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontpage3.jpg
// module id = jgR5
// module chunks = 0